import { httpClient } from "@bw/shared/api";

export type ClubCoachRating = {
  rating_id: string; coach_profile_id: string;
  program_id: string; facility_name_snapshot: string; rating: number;
  created_at: string;
};

export const clubCoachRatingApi = {
  rateable: (programId: string) => httpClient.get<{ coach_profile_id: string; display_name: string }[]>(
    `/coaches/rateable?program_id=${encodeURIComponent(programId)}`),
  list: (coachProfileId: string) => httpClient.get<{ items: ClubCoachRating[]; total: number }>(
    `/coaches/${encodeURIComponent(coachProfileId)}/ratings?limit=500`),
  create: (coachProfileId: string, programId: string, rating: number) =>
    httpClient.post<ClubCoachRating>("/coaches/ratings", {
      coach_profile_id: coachProfileId, program_id: programId, rating,
    }),
};
